/**
 * Decodifica entità HTML (es. &lt; &gt; &amp;) in caratteri reali.
 */
export function decodeHtml(html) {
  if (!html || typeof html !== 'string') return '';
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

/**
 * Rimuove tag HTML e restituisce testo piano (per anteprime, intro).
 * Se la stringa contiene entità escapate, decodifica prima.
 */
export function stripHtml(html) {
  if (html == null || typeof html !== 'string') return '';
  const decoded = decodeHtml(html);
  const tmp = document.createElement('div');
  tmp.innerHTML = decoded;
  return (tmp.textContent || tmp.innerText || '').trim().replace(/\s+/g, ' ');
}

/** Testo piano per meta description / JSON-LD (max 160 caratteri di default). */
export function stripHtmlForMeta(html, maxLen = 160) {
  const plain = stripHtml(html);
  if (!plain) return '';
  return plain.length <= maxLen ? plain : `${plain.slice(0, maxLen - 1).trim()}…`;
}
